<div *ngIf="data?.length" class="ds-radio-group">
  <div
    *ngFor="let option of data"
    [attr.aria-describedby]="ariaDescribedBy"
    [tabIndex]="disabled ? -1 : 0"
    [class.ds-selected]="innerInput.checked"
    [class.ds-disabled]="disabled"
    [class.ds-cursor--not-allowed]="disabled"
    [class.ds-cursor--pointer]="!disabled"
    class="focusable justify-content-start align-items-start focusable__element ds-radio-group--option d-flex flex-nowrap flex-row p-3"
    (click)="innerInput.click(); $event.currentTarget.blur()"
    (keydown.enter)="innerInput.click()"
  >
    <div class="d-flex custom-radio ps-6 ps-sm-5 position-relative">
      <input
        #innerInput
        (change)="value = option.value"
        [disabled]="disabled"
        [checked]="selected?.length && option.value === selected"
        [id]="option.value"
        [attr.aria-label]="option.value"
        [name]="name"
        tabindex="-1"
        class="custom-control-input"
        type="radio"
      />
      <label
        [for]="option.value"
        class="custom-control-label"
        [class.ds-cursor--not-allowed]="disabled"
        [class.ds-cursor--pointer]="!disabled"
      ></label>
      <ng-container *ngIf="option.displayHtml?.length else textOutput">
        <div [class.ds-color--grey-4]="disabled" [innerHTML]="option.displayHtml"></div>
      </ng-container>
      <ng-template #textOutput>
        <div>
          <h4 [class.ds-color--grey-4]="disabled" [class.d-none]="!option.displayTitle"
              class="ds-body ds-font--book ds-color--black mb-0"
              [class.mb-1]="option.displayText || option.value">
            {{option.displayTitle}}
          </h4>
          <p [class.ds-color--grey-4]="disabled" class="w-100 ds-body ds-font--book ds-color--grey-2 mb-0">
            {{option.displayText || option.value}}
          </p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
